<template>
<div id="container" class="walwelt">
    <div class="fullscreen_background">
        <img src="/static/assets/wal/Hintergrund_2860.png" />
    </div>
    <top-menu />
    <top-logo />
    <stoppuhr />
    <lautsprecher />
    <copyright />
    <hintergrundbutton />
<div class="z20 walschuetzer">
    <img class="img" src="/static/assets/wal/Walschuetzer_Schiff.png" />
    </div>
  <div class="walfaenger">
    <img class="img hovering2" src="/static/assets/wal/Walfaengerschiff_bitte_reinfahren_lassen.png" />
    </div>
    <div class="schlauchboot z30">
        <!-- <img class="img" src="/static/assets/wal/Schwimmer.png" /> -->
        <img class="img hovering2" src="/static/assets/wal/Schlauchboot.png" />
    </div>
  <div class="wal z30">
        <!-- <img class="img" src="/static/assets/wal/Schwimmer.png" /> -->
        <img class="img hovering2" src="/static/assets/wal/Bobby_Dick_Unterwasser_ohne_Blasen.png" />
    </div>
  <div class="blubber z30">
        <!-- <img class="img" src="/static/assets/wal/Schwimmer.png" /> -->
        <img class="hovering2 img" src="/static/assets/wal/wal_blubberi.png" />
    </div>
    <div class="wal_gigi z30">
        <img class="img" src="/static/assets/wal/wal_gigi.png" />
    </div>
	
    <router-link to="/olympia" tag="div" class="pfeil_links_big z50 pointer">
        <img class="img" src="/static/assets/alle/Pfeil.png" />
    </router-link>

    <router-link to="/game" tag="div" class="pfeil_rechts_big z50 pointer">
        <img class="img" src="/static/assets/alle/Pfeil-1.png" />
    </router-link>

    <div class="geschichte z50">
        <img src="/static/assets/wal/Textfeld.png" usemap="#geschichte-map">
        <player audiourl="https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies2022_Geschichte_2_Dubix_Beluga.mp3" jsonurl="/static/assets/geschichten/Dubix_Beluga.json" content=".walwelt" target="walwelt_target"/>
        <!-- // eslint-disable-next-line -->
      <vuescrollbar tag="div" class="fliesstext" id="walwelt_target">
<p>Die Sonne lachte am Himmel und das Meer rauschte in schaumigen Wellen. Dubix Beluga lag am Strand unter dem Schatten eines Sonnenschirms und las gebannt das neueste Buch der Walforscherin Lora Blau über die Gesänge der Wale. Da rief ihn Hugi Pott an: „Wir müssen raus. Meeresschützer haben uns angerufen. Ein Wal ist in Not!“ Dubix Beluga sprang auf, sammelte in aller Eile seine sieben Sachen in seinem Handtuch ein und lief barfuß den Strand entlang. Er erreichte den Hafen noch vor den anderen, kletterte auf ihr kleines Walrettungsschiff, schmiss sein Handtuchbündel in eine Ecke und begann, alles startklar zu machen. Jetzt sah er schon Hugi Pott und Gigi Buckel mit Libero Finn den Landesteg herunterrennen. Und da kam auch schon Kapitänin Maxi Cook auf ihrem Roller angerast. Sie begrüßten sich kurz, wechselten sonst aber kein Wort. Alle taten konzentriert ihre Arbeit, um so schnell wie möglich die Leinen loszumachen. Hugi Pott nannte Maxi Cook die Zieldaten, Gigi Buckel überprüfte das Schlauchboot und Dubix Beluga die Rettungsausrüstung. Schnell schlüpften alle in ihre Neoprenanzüge und Libero Finn nahm seinen Platz am Bug des Schiffes ein. Sie wussten, sie durften keine Zeit verlieren, um den Wal zu retten. Vor allem aber mussten sie vor dem Walfänger Yamato Ahab da sein, denn der hatte von dem hilflosen Wal bestimmt schon Wind bekommen. Kurze Zeit später waren sie auf See und Kapitänin Maxi Cook steuerte das Ziel an. Dubix Beluga blickte durch sein Fernrohr. „Da!“, rief er, „da vorne!“ Rasch schnallte er sich seine Sauerstoffflasche um und setzte seine Taucherbrille auf den Kopf. Gigi Buckel und Hugi Pott zogen ihre Schwimmwesten an. Maxi Cook fuhr nun auf das riesige Etwas zu, das an der Meeresoberfläche zappelte.</p>
<p>Es war der Wal Bobby Dick, der sich offensichtlich nicht mehr fortbewegen konnte und jämmerlich sang. Es war ein Hilferuf! Dubix Beluga verstand ihn, denn Walforscherin Lora Blau hatte ihn in ihrem Buch beschrieben. Etwa 200 Meter vor Bobby Dick stoppte Maxi Cook das Schiff. Gigi Buckel und Hugi Pott ließen das Schlauchboot vom Schiff herunter. Gemeinsam mit Dubix Beluga sprangen sie dem Boot nach, kletterten hinein und näherten sich paddelnd Bobby Dick. Jetzt konnten sie genau sehen, was das arme Tier daran hinderte fortzuschwimmen. Um seine riesige Schwanzflosse war mehrmals ein Stahlseil gewunden, aus dem sich der Wal nicht befreien konnte. „Das Stahlseil muss unten festhängen, wahrscheinlich an einem Netzanker!“, rief Dubix Beluga, setzte sich seine Taucherbrille auf die Nase, nahm das Mundstück seines Atemschlauches zwischen die Lippen und ließ sich rückwärts ins Wasser plumpsen. In der Tiefe des Meeres war der herzzerreißende Gesang des Wales noch lauter zu hören. In höchster Eile tauchte Dubix Beluga unter Bobby Dicks gigantischem Leib hindurch, tastete sich am Stahlseil entlang immer tiefer und zersägte es vorsichtig mit den scharfen Zähnen seines Tauchmessers. Als er mit dem Seilende in der Hand oben wieder auftauchte, sah er, wie Gigi Buckel und Hugi Pott Bobby Dick nun vom Seil befreien konnten. Dubix Beluga kletterte zu ihnen ins Boot zurück und warf das Seilende dem herbeigeschwommenen Libero Finn zu. Dieser nahm es ins Maul und schwamm zu dem Körbchen, das Maxi Cook für ihn vom Schiff heruntergelassen hatte. Maxi Cook zog ihn hoch, vertaute das Seil und zog es nach und nach aufs Boot. Es war geschafft! Bobby Dick war befreit und wollte fröhlich ein Dankeslied anstimmen. Doch es blieb keine Zeit zum Jubeln. Der Walfänger Yamato Ahab hatte sie eingeholt. Mit Harpunen bewaffnet standen er und seine Steuerfrau Hulda Hermandottir am Bug ihres Schiffes und zielten auf den Wal. „Wann wirst du endlich verstehen, dass Walfang hier verboten ist?“, schrie ihm Dubix Beluga aus dem Schlauchboot zu. „Ich jage Wale, solange es mir gefällt!“, entgegnete Yamato Ahab lautstark, als er plötzlich mitsamt seinem Schiff emporgehoben wurde. „Hilfe, Hilfe!“, heulte er. Unter seinem Schiff aber tauchte der grinsende Bobby Dick auf. Das Rettungsteam lachte. </p>
<p>Vorsichtig ließ Bobby Dick Yamato Ahabs Schiff wieder herunter, tauchte ab und stieg in seiner ganzen kraftvollen Pracht aus dem Wasser empor. Da schlotterten Yamato Ahab und Hulda Hermandottir am ganzen Körper und versprachen, nie mehr auf Walfang zu gehen, wenn Bobby Dick sie nur in Ruhe ließe. Dieser gab dem Walfängerschiff einen Stupser und schon segelte es davon. Als die Rettungsmannschaft wieder auf ihrem Schiff versammelt war, sprang Bobby Dick plötzlich nochmals aus dem Meer und warf ihnen etwas auf das Schiff. Platsch! Was lag da? Es war Dubix Belugas Walgesang-Buch, das während der hektischen Rettungsaktion im Meer gelandet sein musste. Bobby Dick hatte es aus dem Meer gefischt und seinem Retter zurückgebracht. Zum Abschied blies der Wal noch eine wunderschöne Fontäne und sang seinen neuen FreundInnen ein uraltes Lied, von dem auch das Walgesang-Buch erzählt. Sein unvergesslicher Refrain lautet: </p>
<p><span>Das Lesen ist schön!</span></p>
      </vuescrollbar>
    </div>
</div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Player from '@/components/Player.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'
// import Scrollbar from 'jquery.scrollbar'
import VueScrollBar from 'vue-perfect-scrollbar'
import Hintergrundbutton from '@/components/Hintergrundbutton.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'walwelt',
  data () {
    return {
      who: 'walwelt'
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'player': Player,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright,
    'vuescrollbar': VueScrollBar,
    'hintergrundbutton': Hintergrundbutton
  },
  mounted () {
    this.$ga.page(this.$router)  
    var muted = (typeof window.muted === 'undefined' ? false : window.muted)
    setTimeout(function () {
      if (typeof window.currentAudioX !== 'undefined') {
        try {
          window.currentAudioX.pause()
          window.currentAudioX.currentTime = 0
          window.currentAudioX = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      if (typeof window.currentAudio !== 'undefined') {
        try {
          window.currentAudio.pause()
          window.currentAudio.currentTime = 0
          window.currentAudio = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies2022_Archivseite_Dubix_Titel_Beluga.mp3')
      window.currentAudioX.muted = muted
      window.currentAudioX.play()
      try {
          window.hintergrundSound.pause()
          window.hintergrundSound.currentTime = 0
          window.hintergrundSound = null
      } catch(e){
        console.log('hintergrundsound nicht aktiv')
      }
      window.hintergrundSound = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Dubix_Beluga_Atmo2.mp3')
      window.hintergrundSound.muted = (typeof window.muted !== 'undefined' ? window.muted : false) 
      window.hintergrundSound.loop = true
      try {
        window.hintergrundSound.play()
        window.bgsounddisabled = false
      } catch(e)  {
        window.bgsounddisabled = true
      }  
    }, 1000)
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
        window.hintergrundSound.pause()
        window.hintergrundSound.currentTime = 0
        window.hintergrundSound = null
    } catch(e){
    console.log('hintergrundsound nicht aktiv')
    }
  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::-webkit-scrollbar { background: none !important; }
body {margin:0; padding:0;}

/* Z-Index - Level */

.z1{z-index:10;}
.z2{z-index:20;}
.z3{z-index:30;}
.z4{z-index:40;}
.z5{z-index:50;}
.z6{z-index:60;}
.z7{z-index:70;}
.z8{z-index:80;}
.z9{z-index:90;}
.z10{z-index:100;}
.z11{z-index:110;}
.z12{z-index:120;}
.z13{z-index:130;}
.z14{z-index:140;}
.z15{z-index:150;}
.z16{z-index:160;}
.z17{z-index:170;}
.z18{z-index:180;}
.z19{z-index:190;}
.z20{z-index:200;}
.z21{z-index:210;}
.z22{z-index:220;}
.z23{z-index:230;}
.z24{z-index:240;}
.z25{z-index:250;}
.z26{z-index:260;}
.z27{z-index:270;}
.z28{z-index:280;}
.z29{z-index:290;}
.z30{z-index:300;}
.z31{z-index:310;}
.z32{z-index:320;}
.z33{z-index:330;}
.z34{z-index:340;}
.z35{z-index:350;}
.z36{z-index:360;}
.z37{z-index:370;}
.z38{z-index:380;}
.z39{z-index:390;}
.z40{z-index:400;}
.z41{z-index:410;}
.z42{z-index:420;}
.z43{z-index:430;}
.z44{z-index:440;}
.z45{z-index:450;}
.z46{z-index:460;}
.z47{z-index:470;}
.z48{z-index:480;}
.z49{z-index:490;}
.z50{z-index:500;}

/* walwelt */
.walwelt { position: absolute; width: 1920px; height: 1080px; bottom: 0; }

.walwelt .himmel { display: block !important; }

.walwelt .geschichte { position: absolute; top: 170px; left:51%;  }

.walwelt .pfeil_links_big {position: absolute; left: 1vw; top: 40%;}
.walwelt .pfeil_rechts_big {position: absolute; right: 1vw; top: 40%;}

.wal_gigi.z30 {
    position: absolute;
    top: -277px;
    left: -502px;
    z-index: 50;
    animation: hovering2 22s linear infinite;
    animation-delay: 1s;
}
.z20.walschuetzer {
    position: absolute;
    top: 280px;
    left: 440px;
    z-index: 20;
    animation: hovering2 22s linear infinite;
    animation-delay: 1s;
}    
.schlauchboot.z30 {
    position: absolute;
    left: 150px;
    bottom: 340px;
    z-index: 30;
animation: dubix_erscheint 0.5s ease-out; 
    animation-delay: 0.25s; 
    animation-fill-mode: forwards; 
    opacity:0; 
    transform-origin:bottom center;
    }
.wal .hovering2, .blubber .hovering2 {animation-delay: 0.75s;}    
.wal.z30 {
    position: absolute;
    bottom: 10px;
    left: 1100px;
    animation: wal_erscheint 5s ease-out; animation-delay: 1s; animation-fill-mode: forwards;
}
 .blubber.z30 {
    position: absolute;
    bottom: -280px;
    left: -481px;
    opacity:0;
    animation: blubber_erscheint 1s ease-out; animation-delay: 5s; animation-fill-mode: forwards;
}   
    @keyframes wal_erscheint {
  0% {
    bottom: 10px;
    left: 1100px;
  }
25% {
    bottom: 20px;
  }
50% {
    bottom: 20px;
  }
75% {
    bottom: 0px;
  }        
  100% {
    bottom: 10px;
    left: 590px;
  }
    }

@keyframes dubix_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
@keyframes blubber_erscheint {
    50% { transform: scale(1); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
        
.walfaenger {
    position: absolute;
    left: 150px;
    bottom: 632px;
    opacity: 1;
    animation: walfaenger_erscheint 6s ease-out; animation-delay: 0s; animation-fill-mode: forwards;
}
.walfaenger .hovering2 {animation-delay: 0.35s;}
@keyframes walfaenger_erscheint {
  0% {
    left: 0px;
    bottom: 632px;
    opacity: 1;
    filter: blur(5px);
    transform: scale(0.6);  
  }
  30% {
    opacity: 1;
    filter: blur(0px);
  }
  100% {
    left: 150px;
    bottom: 602px;
    opacity: 1;
    transform: scale(1);  
    filter: blur(0px);
  }
}  
.walwelt .queen.z30 {
    position: absolute;
    top: -283px;
    left: -1203px;
    animation: queen_erscheint 5s ease-out; animation-delay: 1s; animation-fill-mode: forwards;
}  
@keyframes queen_erscheint {
  0% {
    top: -453px;
    left: -1203px;
  }
  100% {
    top: -283px;
    left: -443px;
  }
}  
    
.walwelt .wasserfall {position: absolute; /* left: 23%; bottom: 6%; */}
.walwelt .moeve { position: absolute; top: 250px; left: 600px; }
.walwelt .schild { position: absolute; bottom: 29px; left: 209px; }
    
.fliesstext{
    bottom: 25%;
    left: 10.5%;
    width: 79%;
    font-size: 16pt;
    font-family: 'Open Sans';
    font-weight: 400;
    position: absolute;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 450px;
    padding-right: 15px;
}

/* möve animation */

@-webkit-keyframes hovering /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  25% {
    -ms-transform: translate(20px,30px);
    -moz-transform: translate(20px,30px);
    -webkit-transform: translate(20px,30px);
    -o-transform: translate(20px,30px);
    transform: translate(20px,30px);
  }
  50% {
    -ms-transform: translate(-10px,10px);
    -moz-transform: translate(-10px,10px);
    -webkit-transform: translate(-10px,10px);
    -o-transform: translate(-10px,10px);
    transform: translate(-10px,10px);
  }
  75% {
    -ms-transform: translate(-20px,-20px); 
    -moz-transform: translate(-20px,-20px); 
    -webkit-transform: translate(-20px,-20px);
    -o-transform: translate(-20px,-20px);
    transform: translate(-20px,-20px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.walwelt .hovering1 {
  -webkit-animation: hovering 18s linear infinite;
  -moz-animation: hovering 18s linear infinite;
  -ms-animation: hovering 18s linear infinite;
  -o-animation: hovering 18s linear infinite;
  animation: hovering 18s linear infinite;
}
.walwelt .hovering2 {
  -webkit-animation: hovering2 22s linear infinite;
  -moz-animation: hovering2 22s linear infinite;
  -ms-animation: hovering2 22s linear infinite;
  -o-animation: hovering2 22s linear infinite;
  animation: hovering2 22s linear infinite;
}
.walwelt .hovering3 {
  -webkit-animation: hovering 20s linear infinite;
  -moz-animation: hovering 20s linear infinite;
  -ms-animation: hovering 20s linear infinite;
  -o-animation: hovering 20s linear infinite;
  animation: hovering 20s linear infinite;
}
.walwelt .hovering4 {
  -webkit-animation: hovering 24s linear infinite;
  -moz-animation: hovering 24s linear infinite;
  -ms-animation: hovering 24s linear infinite;
  -o-animation: hovering 24s linear infinite;
  animation: hovering 24s linear infinite;
}
/* schwimmer animation */
@-webkit-keyframes hovering2 /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering2 {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  50% {
    -ms-transform: translate(0px,10px);
    -moz-transform: translate(0px,10px);
    -webkit-transform: translate(0px,10px);
    -o-transform: translate(0px,10px);
    transform: translate(0px,10px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.walwelt .hovering2 {
  -webkit-animation: hovering2 10s linear infinite;
  -moz-animation: hovering2 10s linear infinite;
  -ms-animation: hovering2 10s linear infinite;
  -o-animation: hovering2 10s linear infinite;
  animation: hovering2 10s linear infinite;
}

/*************** SCROLLBAR BASE CSS ***************/
 
.scroll-wrapper {
    overflow: hidden !important;
    padding: 0 !important;
    position: relative;
}
 
.scroll-wrapper > .scroll-content {
    border: none !important;
    box-sizing: content-box !important;
    height: auto;
    left: 0;
    margin: 0;
    max-height: none;
    max-width: none !important;
    overflow: scroll !important;
    padding: 0;
    position: relative !important;
    top: 0;
    width: auto !important;
}
 
.scroll-wrapper > .scroll-content::-webkit-scrollbar {
    height: 0;
    width: 0;
}
 
.scroll-element {
    display: none;
}
.scroll-element, .scroll-element div {
    box-sizing: content-box;
}
 
.scroll-element.scroll-x.scroll-scrollx_visible,
.scroll-element.scroll-y.scroll-scrolly_visible {
    display: block;
}
 
.scroll-element .scroll-bar,
.scroll-element .scroll-arrow {
    cursor: default;
}
 
.scroll-textarea {
    border: 1px solid #cccccc;
    border-top-color: #999999;
}
.scroll-textarea > .scroll-content {
    overflow: hidden !important;
}
.scroll-textarea > .scroll-content > textarea {
    border: none !important;
    box-sizing: border-box;
    height: 100% !important;
    margin: 0;
    max-height: none !important;
    max-width: none !important;
    overflow: scroll !important;
    outline: none;
    padding: 2px;
    position: relative !important;
    top: 0;
    width: 100% !important;
}
.scroll-textarea > .scroll-content > textarea::-webkit-scrollbar {
    height: 0;
    width: 0;
}
 
/*************** SIMPLE INNER SCROLLBAR ***************/
 
.scrollbar-inner > .scroll-element,
.scrollbar-inner > .scroll-element div
{
    border: none;
    margin: 0;
    padding: 0;
    position: absolute;
    z-index: 10;
}
 
.scrollbar-inner > .scroll-element div {
    display: block;
    height: 100%;
    left: 0;
    top: 0;
    width: 100%;
}
 
.scrollbar-inner > .scroll-element.scroll-x {
    bottom: 2px;
    height: 8px;
    left: 0;
    width: 100%;
}
 
.scrollbar-inner > .scroll-element.scroll-y {
    height: 100%;
    right: 2px;
    top: 0;
    width: 8px;
}
 
.scrollbar-inner > .scroll-element .scroll-element_outer {
    overflow: hidden;
}
 
.scrollbar-inner > .scroll-element .scroll-element_outer,
.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
}
 
.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)";
    filter: alpha(opacity=40);
    opacity: 0.4;
}
 
.scrollbar-inner > .scroll-element .scroll-element_track { background-color: #e0e0e0; }
.scrollbar-inner > .scroll-element .scroll-bar { background-color: #c2c2c2; }
.scrollbar-inner > .scroll-element:hover .scroll-bar { background-color: #919191; }
.scrollbar-inner > .scroll-element.scroll-draggable .scroll-bar { background-color: #919191; }

/* update scrollbar offset if both scrolls are visible */
 
.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track { top: -12px; }

.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size { top: -12px; }

::-webkit-scrollbar {
    width: 15px;
}
 
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0px #ac8a69; 
    box-shadow: inset 0 0 0px #ac8a69; 
    -webkit-border-radius: 0;
    border-radius: 0;
}
 
::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #ac8a69; 
}
::-webkit-scrollbar-thumb:window-inactive {
    background: #ac8a69; 
}
::-webkit-scrollbar-button {
    background: none;
}
::-webkit-scrollbar-button:start:decrement,
::-webkit-scrollbar-button:end:increment {
  height: 20px;
  width: 20px;
  display: none;
  background-repeat: no-repeat; 
}
.blubber.blubber_animation {
    top: -25%;
    left: -25%;
    position: absolute;
}
.walwelt .john {
    position: absolute;
    top: 248px;
    left: 787px;
  animation: dubix_erscheint 1s ease-out; animation-delay: 0.5s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;
}
.walwelt .drohne {
    position: absolute;
    top: -320px;
    left: -580px;
}

@keyframes blubber_animation {
    100% { background-position: 0 -9720px; }
}
.walwelt .wassergeist {position: absolute; top: 871px; left: 10px;}
.wassergeist_animation {
  width: 122px;
  height: 204px;
  background: url('/static/assets/wal/Wassergeist_Animation.png') top center;
  animation-delay: 1s;
  animation: wassergeist_animation 15s steps(15) infinite;
  transform: scale(1);
  margin-top: 0px;
}

@keyframes wassergeist_animation {
    0% { background-position: 0 -0px; }
    10% { background-position: 0 -3060px; }
    100% { background-position: 0 -3060px; }
}	
span { font-family: FrozenMemory; } 
.player {
    position: absolute;
    top: 660px !important;
    left: 110px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Wal.vue